/* ProminentSection.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "@media (min-width:64rem){._1jqu1ssb:before{width:50%}._mszq1n8h:before{height:70%}._dryrzwfg:before{border-radius:2pc}}";
const _11 = "@media (min-width:48rem){._4792accp:before{top:var(--ds-space-negative-300)}._ujk9accp:before{left:var(--ds-space-negative-300)}._4h6x13sl:before{width:85%}._wz931nrf:before{height:60%}._3uq51gwv:before{min-height:360px}._1dmf1tcg:before{border-radius:24px}}";
const _10 = "._1g0v1mrw:before{z-index:-1}";
const _9 = "._rfx37vkz:before{border-radius:1pc}";
const _8 = "._1rusjzbi:before{background-color:var(--ds-background-accent-purple-subtlest)}";
const _7 = "._qnec1410:before{left:var(--ds-space-negative-150)}";
const _6 = "._1auk1410:before{top:var(--ds-space-negative-150)}";
const _5 = "._kfgt1vuk:before{height:90%}";
const _4 = "._1mp4fknx:before{width:calc(100% + 24px)}";
const _3 = "._1cs8stnw:before{position:absolute}";
const _2 = "._1kt9b3bt:before{content:\"\"}";
import { media } from '@atlaskit/primitives/responsive';
import React from 'react';
const _ = "._kqswh2mm{position:relative}";
const ProminentSectionWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_kqswh2mm", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ProminentSectionWrapper.displayName = 'ProminentSectionWrapper';
}
const ProminentSectionBackground = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1kt9b3bt _1cs8stnw _1mp4fknx _kfgt1vuk _1auk1410 _qnec1410 _1rusjzbi _rfx37vkz _1g0v1mrw _4792accp _ujk9accp _4h6x13sl _wz931nrf _3uq51gwv _1dmf1tcg _1jqu1ssb _mszq1n8h _dryrzwfg", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ProminentSectionBackground.displayName = 'ProminentSectionBackground';
}
export const ProminentSection = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/React.createElement(ProminentSectionWrapper, null, /*#__PURE__*/React.createElement(ProminentSectionBackground, null, children));
};